import React from "react";

// A single-value ring for eligibility % (0..1)
function ProgressRing({ value = 0, size = 64, thickness = 6, color = "#00e5ff", label, sub }) {
  const clamped = Math.max(0, Math.min(1, value));
  const radius = (size - thickness) / 2;
  const cx = size / 2;
  const circumference = 2 * Math.PI * radius;
  const dash = circumference * clamped;
  return (
    <div style={{ position: "relative", width: size, height: size, display: "inline-block" }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ transform: "rotate(-90deg)" }}>
        <circle cx={cx} cy={cx} r={radius} fill="none" stroke="rgba(139, 155, 209, 0.1)" strokeWidth={thickness} />
        <circle
          cx={cx}
          cy={cx}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={thickness}
          strokeLinecap="round"
          strokeDasharray={`${dash} ${circumference}`}
          style={{ filter: `drop-shadow(0 0 4px ${color})` }}
        />
      </svg>
      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          pointerEvents: "none",
        }}
      >
        {label && (
          <div style={{ fontFamily: "var(--font-display)", fontSize: size > 80 ? 16 : 12, fontWeight: 700, color: "var(--text-primary)", lineHeight: 1 }}>
            {label}
          </div>
        )}
        {sub && <div style={{ fontSize: 9, color: "var(--text-muted)", marginTop: 2 }}>{sub}</div>}
      </div>
    </div>
  );
}

export default ProgressRing;
